import { render, staticRenderFns } from "./UserAgreement.vue?vue&type=template&id=46ee20ee&scoped=true&"
import script from "./UserAgreement.vue?vue&type=script&lang=js&"
export * from "./UserAgreement.vue?vue&type=script&lang=js&"
import style0 from "./UserAgreement.vue?vue&type=style&index=0&id=46ee20ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ee20ee",
  null
  
)

export default component.exports